/*
 * Copyright (c) 2022. Haodong JU
 */

import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'
import ConsumeType from '@/model/buffet/ConsumeType'
import WeekDays from '@/model/common/WeekDays'
import IKUtils from 'innerken-js-utils'
import { showSuccessMessage } from '@/common/utils'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start',
    },
    header: false,
    formConfig: {
      requiredNew: false,
    },
    form: false,
  },

  fromTime: {
    type: IKDataEntity.Types.Time,
    // displayName: 'Zeit ab',
  },
  toTime: {
    type: IKDataEntity.Types.Time,
    // displayName: 'end_time',
  },

  consumeTypeId: {
    // displayName: 'name',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: ConsumeType.getList,
        itemText: 'name',
      },
    },
    form: false,
    header: false,
  },

  dayOfWeek: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: WeekDays.getList(),
        itemText: 'name',
        multiple: true,
      },
    },
  },
}

const config = {

  load: async function (filter) {
    console.log(filter)
    console.trace()
    return ((await hillo.get('ConsumeType.php?op=showConsumeTypeTimeSpanByConsumeType',
      ...filter,
    ))
      .content)
  },
  add: async function (item) {
    const tempItem = item
    console.log(tempItem, 'tempItem')
    for (const dayOfWeek of item.dayOfWeek) {
      tempItem.dayOfWeek = dayOfWeek
      hillo.post('ConsumeType.php?op=addConsumeTypeTimeSpan', {
        ...tempItem,
      }, {
        showLoading: false,
      })
    }
  },
  remove: function (id) {
    return hillo.post('ConsumeType.php?op=deleteConsumeTypeTimeSpan', { id: id })
  },
  edit: function (item) {
    console.log('edit item', item)
    return hillo.postWithUploadFile('ConsumeType.php?op=editConsumeTypeTimeSpan', item, {
      showLoading: true,
    })
  },
  resetTimeSpan: async function (list) {
    IKUtils.showLoading(true)
    for (const item of list) {
      item.fromTime = '00:00:00'
      item.toTime = '23:59:59'
      hillo.postWithUploadFile('ConsumeType.php?op=editConsumeTypeTimeSpan', item, {
        showLoading: false,
      })
    }
    showSuccessMessage('OK')
  },

}

export default IKDataEntity.ModelFactory(entity, config)
